/**
 * @module Footer
 * @description
 */
import React, { FC } from "react";
import SocialMenu from "~/core/SiteNavigation/menus/SocialMenu";
import FooterMenu from "~/core/SiteNavigation/menus/FooterMenu";
import SiteLegal from "~/core/SiteLegal";
import CopyrightMenu from "~/core/SiteNavigation/menus/CopyrightMenu";
import {
  socialLinks,
  footerLinks,
  copyrightLinks,
} from "~/core/SiteNavigation/links";
import { Container } from "ui/components/Grid";
import Link from "next/link";
import styles from "./index.module.css";
import { trackEvent } from "ui/js/helpers/tracking";
import { MonarchSlot } from '@redventures/cohesion-utils-react';

interface Props {}

const Footer: FC<Props> = () => {
  const pathname = typeof window !== "undefined" ? window.location.pathname : "";

  const handleOnClick = (
    e: React.MouseEvent<HTMLAnchorElement>,
    href: string,
    number: string
  ) => {
    trackEvent({
      action: "elementClicked",
      data: {
        elementType: "phonelink",
        location: pathname,
        position: "footer",
        href: href,
        number: number,
      },
    });
  };

  const PHONE_NUMBER = "18668893199";
  const PHONE_HYPER_LINK = "tel:" + PHONE_NUMBER;
  return (
    <footer id="colophon" className={styles.siteFooter} role="contentinfo">
      <div className={styles.siteFooterPrimary}>
        <FooterMenu links={footerLinks} />
      </div>

      <Container>
        <>
          <MonarchSlot slotId="smbLpGlobalFooterLegal">
            <SiteLegal />
          </MonarchSlot>

          <address
            className={styles.vcard}
            itemScope
            itemType="http://schema.org/Organization"
          >
            <div className={styles.addressWrap}>
              <div className={styles.org} itemProp="name">
                Frontier Business
              </div>
              <div
                className={styles.adr}
                itemProp="address"
                itemScope
                itemType="http://schema.org/PostalAddress"
              >
                <div itemProp="streetAddress">
                  <span className={styles.streetAddress}>
                    1919 McKinney Ave.
                  </span>
                </div>
                <span className={styles.locality} itemProp="addressLocality">
                  Dallas
                </span>
                ,&nbsp;
                <span className={styles.region} itemProp="addressRegion">
                  TX{" "}
                </span>
                <span className={styles.postalCode} itemProp="postalCode">
                  75201
                </span>
              </div>
            </div>
            <div className={styles.tel} itemProp="telephone">
              <span>For sales and customer service,</span> call{" "}
              <Link
                href={PHONE_HYPER_LINK}
                onClick={(e) =>
                  handleOnClick(e, PHONE_HYPER_LINK, PHONE_NUMBER)
                }
              >
                <span className="screen-reader-text">Phone number</span>{" "}
                1.866.889.3199
              </Link>
            </div>
          </address>

          <div className={styles.siteFooterSecondary}>
            <p className={styles.siteCopyright}>
              &copy; {new Date().getFullYear()} Frontier Communications Parent,
              Inc. All rights reserved.
            </p>

            <div className={styles.siteFooterMenuWrap}>
              <CopyrightMenu links={copyrightLinks} />
              <SocialMenu links={socialLinks} />
            </div>
          </div>
        </>
      </Container>
    </footer>
  );
};

Footer.displayName = "Footer";

export default Footer;
